<template>
    <div>
        <div class="page-title view-template-header">
            <h4> {{$t('txt.sablonOferta')}} </h4>
            <div class="table-header vw-offer-header">
                <div class="search-box" v-if="$can(['update offer'])">
                    <router-link :to="{ name: 'edit-offer-template', params: { id: templates.id }}">
                        <button type="button" class="add-user edit-button">
                            <i class="far fa-edit"></i>
                            <span> {{$t('placeholder.editeaza')}} </span>
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="view-template-title">
            <h4 v-html="templates.name"></h4>
        </div>
        <div class="view-template-body" v-html="templates.text">
        </div>
    </div>
</template>
<script>
import OfferTemplatesService from '../../api-services/offer-templates.service.js'
export default {
  name: 'ViewOfferTemplate',
  data () {
    return {
      templates: {
        name: null,
        text: null
      }
    }
  },
  methods: {
    getTemplates () {
      this.templates = null
      this.$store.dispatch('showLoading')
      OfferTemplatesService.get(this.$route.params.id)
        .then((response) => {
          this.templates = response.data.data
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
  },
  mounted () {
    this.getTemplates()
  }
}
</script>
